import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../hooks/useAuth';

const UploadSong = () => {
  const { songid } = useParams();
  const { authToken } = useAuth();
  const [song, setSong] = useState(null);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const fetchSong = async () => {
      try {
        const res = await axios.get(`/api/song/${songid}`);
        // Extract the song data from the nested 'song' object in the response
        setSong(res.data.song || res.data);
      } catch (err) {
        setError('Failed to fetch song metadata');
      }
    };
    fetchSong();
  }, [songid]);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setSuccess(false);
    setError('');
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      setError('Please select a file to upload.');
      return;
    }
    setUploading(true);
    setError('');
    setSuccess(false);
    try {
      const formData = new FormData();
      formData.append('file', file);
      // Always use songid from the URL
      formData.append('songid', songid);
      const res = await axios.post('/api/song/upload', formData, {
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      if (res.status === 200 || res.status === 201) {
        setSuccess(true);
      } else {
        setError(res.data?.error || 'Upload failed');
      }
    } catch (err) {
      setError('Upload failed');
    } finally {
      setUploading(false);
    }
  };

  if (!authToken) {
    return (
      <div className="max-w-xl mx-auto p-4">
        <h2 className="text-2xl font-bold mb-4">Upload Audio File</h2>
        <div className="text-red-500">You must be logged in to upload a file.</div>
      </div>
    );
  }

  return (
    <div className="max-w-xl mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Upload Audio File</h2>
      {song ? (
        <div className="mb-4">
          <div><b>Title:</b> {song.title}</div>
          <div><b>Artist:</b> {song.artist || song.artist_name}</div>
          <div><b>Platform:</b> {song.platform}</div>
          <div><b>Status:</b> {song.status}</div>
        </div>
      ) : (
        <div>Loading song metadata...</div>
      )}
      <form onSubmit={handleUpload} className="space-y-4">
        <input type="file" accept="audio/*" onChange={handleFileChange} disabled={uploading} />
        <button type="submit" className="btn btn-primary" disabled={uploading || !file}>
          {uploading ? 'Uploading...' : 'Upload'}
        </button>
      </form>
      {error && <div className="text-red-500 mt-2">{error}</div>}
      {success && <div className="text-green-600 mt-2">Upload successful!</div>}
    </div>
  );
};

export default UploadSong;
